import * as RadixDialog from '@radix-ui/react-dialog'
import React from 'react'
import styled from 'styled-components'

import { CloseIcon, Separator as Separator_ } from '@blade/ui-kit'

type Props = {
  title?: React.ReactNode
  children?: React.ReactNode
}

export function DialogHeaderBordered(props: Props) {
  return (
    <Root>
      <Title>
        <TitleContent>
          {props.children ? props.children : props.title}
        </TitleContent>

        <CloseButton>
          <CloseIcon size={20} />
        </CloseButton>
      </Title>
      <Separator />
    </Root>
  )
}

const Root = styled(RadixDialog.Title)`
  display: grid;
  align-items: center;
  position: relative;

  padding-inline: 10px;
  padding-block: 10px 6px;
`

const Title = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr auto;
  gap: 5px;
`

const TitleContent = styled.div`
  color: var(--text-11);
  font-size: 14px;
  font-weight: 500;
`

const CloseButton = styled(RadixDialog.Close)`
  all: unset;
  cursor: pointer;
  box-sizing: border-box;

  color: var(--textA-8);

  &:hover {
    color: var(--text-12);
  }
`

const Separator = styled(Separator_)`
  position: absolute;
  bottom: 0;
  left: 10px;
  right: 10px;
`

DialogHeaderBordered.CloseButton = CloseButton
